import { render, staticRenderFns } from "./SayfaGuncelle.vue?vue&type=template&id=6c0c694b&scoped=true&"
import script from "./SayfaGuncelle.vue?vue&type=script&lang=js&"
export * from "./SayfaGuncelle.vue?vue&type=script&lang=js&"
import style0 from "./SayfaGuncelle.vue?vue&type=style&index=0&id=6c0c694b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c694b",
  null
  
)

export default component.exports